export const updateQuery = (params: string) => {
  const { pathname, host, protocol } = window.location
  const url = `${protocol}//${host}${pathname}?${params}`
  window.history.pushState({ path: url }, '', url)
}
